// Libs
import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Formik } from "formik";
import * as Yup from "yup";

// Utils
import { DayOfTheWeek } from "src/types/enum/DayOfTheWeek";
import { OfferStatus, ServiceTime } from "src/types/offerSlot";
import { DomainDisplay, DomainField, DomainKeyEnum, useBuildDomains } from "..";

const useDomainDemoStyles = makeStyles({
    label: { width: "200px", display: "inline-block" },
});

export function DomainDemo(): JSX.Element {
    const classes = useDomainDemoStyles();
    const domains = useBuildDomains();

    return (
        <Formik
            initialValues={{
                [DomainKeyEnum.Amount]: 1000,
                [DomainKeyEnum.AmountDecimal]: 1000,
                [DomainKeyEnum.IdName]: { id: 1, name: "Tous les clients" },
                [DomainKeyEnum.Boolean]: true,
                [DomainKeyEnum.Date]: new Date(),
                [DomainKeyEnum.DateTime]: new Date(),
                [DomainKeyEnum.Days]: DayOfTheWeek.TUESDAY,
                [DomainKeyEnum.MarketingActionStatus]: OfferStatus.Ongoing,
                [DomainKeyEnum.ServiceTime]: ServiceTime.Dinner,
                [DomainKeyEnum.Time]: "12:15",
            }}
            validationSchema={Yup.object().shape({
                [DomainKeyEnum.Amount]: domains[DomainKeyEnum.Amount].schema,
                [DomainKeyEnum.AmountDecimal]: domains[DomainKeyEnum.AmountDecimal].schema,
                [DomainKeyEnum.IdName]: domains[DomainKeyEnum.IdName].schema,
                [DomainKeyEnum.Boolean]: domains[DomainKeyEnum.Boolean].schema,
                [DomainKeyEnum.Date]: domains[DomainKeyEnum.Date].schema,
                [DomainKeyEnum.DateTime]: domains[DomainKeyEnum.DateTime].schema,
                [DomainKeyEnum.Days]: domains[DomainKeyEnum.Days].schema,
                [DomainKeyEnum.MarketingActionStatus]:
                    domains[DomainKeyEnum.MarketingActionStatus].schema,
                [DomainKeyEnum.ServiceTime]: domains[DomainKeyEnum.ServiceTime].schema,
                [DomainKeyEnum.Time]: domains[DomainKeyEnum.Time].schema,
            })}
            // biome-ignore lint/suspicious/noConsole: legacy
            onSubmit={() => console.log("submit")}
        >
            {({ values, setFieldValue }) => (
                <div>
                    {Object.values(DomainKeyEnum).map((domainKey) => (
                        <Box m={2} key={domainKey}>
                            <div>{domainKey}</div>
                            <div>
                                <label className={classes.label}>rawValue</label>
                                <span>{JSON.stringify(values[domainKey])}</span>
                            </div>
                            <div>
                                <label className={classes.label}>displayFormatter</label>
                                <DomainDisplay domainKey={domainKey} value={values[domainKey]} />
                            </div>
                            <div>
                                <label className={classes.label}>displayShortFormatter</label>
                                <DomainDisplay
                                    domainKey={domainKey}
                                    variant="short"
                                    value={values[domainKey]}
                                />
                            </div>

                            <div>
                                <label className={classes.label}>InputComponent</label>
                                {[
                                    DomainKeyEnum.Amount,
                                    DomainKeyEnum.AmountDecimal,
                                    DomainKeyEnum.Boolean,
                                ].includes(domainKey) && (
                                    <DomainField
                                        domainKey={domainKey}
                                        value={values[domainKey]}
                                        inputProps={{
                                            onChange: (value) => {
                                                setFieldValue(domainKey, value);
                                            },
                                        }}
                                    />
                                )}
                            </div>
                        </Box>
                    ))}
                </div>
            )}
        </Formik>
    );
}
